<template>
  <div
    class="border border-gray-300 p-5 hover:shadow-xl rounded cursor-pointer"
  >
    <div class="flex" @click="openLink">
      <div>
        <h1
          class="
            font-AlternateGotFont
            md:text-5xl
            text-4xl text-STblue
            mb-2
            uppercase
          "
        >
          {{ header }}
        </h1>
        <p
          class="
            font-AvenirBlackFont
            md:text-lg
            text-md text-gray-500
            uppercase
          "
        >
          Posted: {{ date | formatDate }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import "../../utils/filters";

export default {
  name: "JobPosting",
  props: {
    header: String,
    date: String,
    identifier: String,
    previewMode: Boolean,
  },

  methods: {
    openLink() {
      if (!this.previewMode) {
        this.$router.push({
          name: "JobPostingPage",
          params: { id: this.identifier },
        });
      }
    },
  },
};
</script>
